import { render, staticRenderFns } from "./ProfesionalConfienza.vue?vue&type=template&id=1d6af1bc&scoped=true&"
import script from "./ProfesionalConfienza.vue?vue&type=script&lang=js&"
export * from "./ProfesionalConfienza.vue?vue&type=script&lang=js&"
import style0 from "./ProfesionalConfienza.vue?vue&type=style&index=0&id=1d6af1bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6af1bc",
  null
  
)

export default component.exports